/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable react/jsx-indent */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import ContainerFlex from '../containerFlex';
import * as St from './styles';
import Input from '../newInput';

export interface IOption {
  readonly id?: string | number;
  value: string;
  [key: string]: any;
}

export type InputProps = {
  id?: string;
  label?: string;
  disabled?: boolean;
  errorMessage?: string;
  options: IOption[];
  value?: string;
  onChange?: (option: IOption) => void;
  onFocus?: (isOpen: boolean) => void;
  readOnly?: boolean;
  heightWhenOpen?: string;
  continerOptionsStyle?: React.CSSProperties;
  getOptionKey?: (option: IOption) => any;
  filterFunction?: (options: IOption[], filterText: string) => IOption[];
};

const AutoCompleteSelect = ({
  label,
  value = null,
  errorMessage,
  onChange,
  readOnly,
  options = [],
  disabled,
  heightWhenOpen,
  continerOptionsStyle,
  defaultValue,
  getOptionKey,
  filterFunction = (options, text) =>
    options.filter((option) =>
      option.value
        .toLowerCase()
        .replaceAll(' ', '')
        .replace(/[^a-zA-Z0-9 ]/g, '')
        .trim()
        .includes(text.toLocaleLowerCase().replaceAll(' ', '').trim()),
    ),
  onFocus,
}: InputProps): JSX.Element => {
  const [isFocused, setIsFocused] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState(() => options);
  const [selectedValue, setSelectedValue] = useState<string>(() => value);

  const [filterText, setFilterText] = useState('');
  const handleToggleFocus = () => {
    if (!readOnly) setIsFocused((prev) => !prev);
  };

  useEffect(() => {
    if (onFocus) {
      onFocus(isFocused);
    }
  }, [isFocused]);
  useEffect(() => {
    if (!value) setSelectedValue(null);
  }, [value]);

  useEffect(() => {
    setFilteredOptions(options);
  }, [options]);

  const handleSelectValue = (value: IOption) => {
    onChange(value);
    setSelectedValue(value.value);
    setFilteredOptions(options);
  };

  const handleFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setFilterText(value);

    setSelectedValue(null);
    if (!value.length) {
      setFilteredOptions(options);
      setFilterText('');
      return;
    }
    setFilteredOptions(filterFunction(options, value));
  };
  return (
    <ContainerFlex
      onFocus={handleToggleFocus}
      onBlur={(e) => {
        const relatedTarget = e.relatedTarget as HTMLElement;
        if (relatedTarget && relatedTarget.classList.contains('option')) {
          return;
        }
        if (!selectedValue && filterText) {
          setSelectedValue('');
          setFilteredOptions(options);
          setFilterText('');
        }
        setIsFocused(false);
      }}
      row
      flex="0"
    >
      <St.Container disabled={disabled} isFocused={isFocused}>
        <ContainerFlex row space>
          <Input
            placeholder=""
            label={label}
            value={selectedValue}
            icon={FiChevronDown}
            defaultValue={value}
            onChange={handleFilter}
            autoComplete="none"
          />
        </ContainerFlex>

        <St.ContainerOptions
          heightWhenOpen={heightWhenOpen}
          isFocused={isFocused}
          style={{ ...continerOptionsStyle }}
        >
          <div className="scrollable">
            {filteredOptions.length > 0 ? (
              filteredOptions?.map((option, index) => (
                <button
                  type="button"
                  key={index}
                  data-option={option.value}
                  className="option"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleSelectValue(option);
                    setIsFocused(false);
                  }}
                >
                  {option?.value}
                </button>
              ))
            ) : (
              <div className="optionDisabled">Sem resultados</div>
            )}
          </div>
        </St.ContainerOptions>

        {errorMessage && <St.ErrorMessage>{errorMessage}</St.ErrorMessage>}
      </St.Container>
    </ContainerFlex>
  );
};

export default AutoCompleteSelect;
